import React, { Component } from 'react';
import { HashRouter, Route, Switch, BrowserRouter } from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'
import ReactGA from 'react-ga';

// Containers
import { DefaultLayout } from './containers';
// Pages
// import { Login, Page404, Page500, Register } from './views/Pages';
import axios from 'axios';

import { Provider } from 'react-redux';

import store from './store';

// import { renderRoutes } from 'react-router-config';

class App extends Component {

    state = { users: []};

    constructor(props) {
        super(props);

        setInterval(this.checkUserAuthenticated, 20000);
    }

    componentDidMount() {
        // ReactGA.initialize('G-MFBZGHS64H');
        // ReactGA.pageview('Init page view');
    }

    checkUserAuthenticated() {

        axios.get('/api/client/agent/validate')
            .then(res => {
                if(res.data !== true) {
                    window.location.href = '/';
                }

            })
            .catch(err => {
                window.location.href = '/';
            })

    }

    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <Switch>
                        {/*<Route exact path="/login" name="Login Page" component={Login} />*/}
                        {/*<Route exact path="/register" name="Register Page" component={Register} />*/}
                        {/*<Route exact path="/404" name="Page 404" component={Page404} />*/}
                        {/*<Route exact path="/500" name="Page 500" component={Page500} />*/}
                        <Route path="/" name="Home" component={DefaultLayout}  />
                    </Switch>
                </BrowserRouter>
            </Provider>
    );
  }
}

export default App;
